import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import firebase from 'firebase/compat/app';
import { concatMap, map, tap } from 'rxjs/operators';
import { NgrxService, RudderStack } from 'src/app/services';
import { environment } from 'src/environments/environment';

@Injectable()
export class ProfileService {
	profileServiceName = 'Profile';
	constructor(
		private http: HttpClient,
		private ngrxService: NgrxService,
		private rudderStack: RudderStack,
	) {}

	loadProfileAPI() {
		return this.ngrxService
			.loadInitAPI(this.profileServiceName, 'profile')
			.pipe(
				concatMap(() =>
					this.http.get<any>(
						`${environment.url.profile}/email/${
							firebase.auth().currentUser?.email
						}`,
					),
				),
				tap((data: any) => {
					this.rudderStack.currentProfileId = data.id;
				}),
				tap(data => {
					this.ngrxService.loadInitData(
						this.profileServiceName,
						'profile',
						data,
					);
				}),
			);
	}

	loadProfileInit() {
		this.ngrxService.init(this.profileServiceName, 'profile');
	}

	loadProfileData(): any {
		return this.ngrxService.loadData(this.profileServiceName, 'profile');
	}

	getProfile(profileId: number) {
		return this.http
			.get<any>(`${environment.url.profile}/id/${profileId}`)
			.pipe(
				map(people => ({
					...people,
					isSocial:
						people.linkedIn ||
						people.linkedin ||
						people.twitterHandle ||
						people.twitter ||
						people.website ||
						people.calendlyLink ||
						people.resume,
					certificateURL: people.courses
						.filter(({ qrCode }: any) => qrCode)
						.map((course: any) => ({
							...course,
							certificateURL: `${environment.url.cohort}/certificate/${course.qrCode}`,
						})),
				})),
			);
	}
}
